import { Component, OnInit, Input, OnChanges, ElementRef } from '@angular/core';
import { tAccessPolicy, canAccess } from '../../classes/access-policy.class';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'access-policy',
  templateUrl: './access-policy.component.html',
  styleUrls: ['./access-policy.component.css']
})
export class AccessPolicyComponent implements OnChanges {
  @Input()
  private policy: tAccessPolicy;
  @Input()
  public tooltip: string = 'אין ברשותך את ההרשאות הנדרשות';
  @Input()
  public hide: boolean = false;
  @Input()
  public disabled: boolean = true;

  public authorized: boolean;

  constructor(private auth: AuthService, private elem: ElementRef<HTMLElement>) {}

  ngOnChanges() {
    this.authorized = (this.auth.user && canAccess(this.auth.userData.authorization, this.policy)) || false;
    this.appendDisabled();
  }

  private async appendDisabled() {
    if (!this.disabled) return;

    setTimeout(() => {
      const elems = this.elem.nativeElement.querySelectorAll('button');

      elems.forEach(elem => (elem.disabled = !this.authorized));
    }, 0);
  }
}
